module.exports = __webpack_public_path__ + "static/media/IconConfirmFiltroB.1afb9bd7.svg";